import styled from "styled-components";

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Container = styled.div`
  position: relative;
  flex-grow: 1;
  width: calc((100% / 3) - 5px * 2);
  margin: 5px;

  @media screen and (max-width: 992px) {
  }
`;

export const Image = styled.img`
  cursor: pointer;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;
